import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Switch, withRouter } from 'react-router-dom';
import { ProtectedRoute } from '../helpers/ProtectedRoute';
import Security from '../components/security/Security';
import Vigilants from '../components/security/Vigilants';
import CreateVigilants from '../components/security/CreateVigilants';
import VigilantShow from '../components/security/VigilantShow';

const SecurityRoutes = ({ match: { url } }) =>
    <Switch>
        <ProtectedRoute exact path={`${url}`} rols={['manager', 'property']} component={Security} />
        <ProtectedRoute exact path={`${url}/vigilants`} rols={['manager', 'property']} component={Vigilants} />
        <ProtectedRoute exact path={`${url}/vigilants/:authId/edit`} rols={['manager']} component={CreateVigilants} />
        <ProtectedRoute exact path={`${url}/vigilants/create`} rols={['manager']} component={CreateVigilants} />
        <ProtectedRoute exact path={`${url}/vigilants/:id`} rols={['manager', 'property']} component={VigilantShow} />
        <Redirect to="/errors/404" />
    </Switch>

SecurityRoutes.propTypes = { match: PropTypes.object.isRequired };

export default withRouter(SecurityRoutes);